import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchNotChooseList, fetchChooseList, updateMenuRelation } from '@/api/system/menu/menu';
import krryPaging from '@/components/paging/index.js';
export default {
  components: {
    krryPaging: krryPaging
  },
  props: ['keyValue', 'showDialog'],
  data: function data() {
    return {
      boxTitle: ['接口', '选中接口'],
      dataList: [],
      selectedData: [] // 已选中

    };
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.getChooseList();
      }
    }
  },
  created: function created() {
    this.getChooseList();
  },
  methods: {
    onChangeData: function onChangeData(val) {// console.log('监听数据改变：', val)
    },
    clearQuery: function clearQuery(position) {
      this.$refs.paging.clearQueryInp(position);
    },
    getData: function getData(index) {// const data = this.$refs.paging.getSelectedData()
      // console.log('通过钩子获取：', data)
    },
    getPageData: function getPageData(pageIndex, pageSize) {
      var _this = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var query, resData;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                query = {
                  limit: pageSize,
                  page: pageIndex,
                  menuId: _this.keyValue
                };
                _context.next = 3;
                return fetchNotChooseList(query);

              case 3:
                resData = _context.sent;
                resData = resData.data.data;
                resData.forEach(function (item) {
                  item.id = item.interfaceId;
                  item.label = item.interfaceUrl;
                });
                return _context.abrupt("return", resData);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getSearchData: function getSearchData(keyword, pageIndex, pageSize) {
      var _this2 = this;

      return _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var query, resData;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                query = {
                  limit: pageSize,
                  page: pageIndex,
                  menuId: _this2.keyValue,
                  interfaceUrl: keyword
                };
                _context2.next = 3;
                return fetchNotChooseList(query);

              case 3:
                resData = _context2.sent;
                resData = resData.data.data;
                resData.forEach(function (item) {
                  item.id = item.interfaceId;
                  item.label = item.interfaceUrl;
                });
                return _context2.abrupt("return", resData);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', false);
    },
    handCreate: function handCreate() {
      var _this3 = this;

      var data = this.$refs.paging.getSelectedData(); // console.log(data)
      // if (data.length === 0) {
      //   this.$message.error('请先选择数据')
      // } else {

      updateMenuRelation({
        interfaceIds: data,
        menuId: this.keyValue
      }).then(function (res) {
        if (res.data.code === 200) {
          _this3.$notify({
            title: '成功',
            message: '接口配置成功',
            type: 'success'
          });

          _this3.$emit('handCancle', true);
        }
      }); // }
    },
    getChooseList: function getChooseList() {
      var _this4 = this;

      fetchChooseList({
        menuId: this.keyValue
      }).then(function (res) {
        if (res.data.code === 200) {
          var selectedData = res.data.data ? res.data.data : [];
          selectedData.forEach(function (item) {
            item.label = item.interfaceUrl;
            item.id = item.interfaceId;
          });
          _this4.selectedData = selectedData;
        }
      });
    }
  }
};